import axios from "axios";


// const baseUrl = "http://localhost:63307/api/";
// const baseUrl = "http://52.152.163.235:63306/api/";
const baseUrl = "https://niraconnect.nirasystems.com/api/api/";
//  const baseUrl = "http://13.68.220.177:63306/api/";
//  const baseUrl = "http://20.169.140.220:63306/api/";
const token = localStorage.getItem('token');
export default {
  // Accounts api's-----------------------------------------------------------------
  account(url = baseUrl + "Account/") {
    return {
      // login
      login: (formData) =>
        axios.post(url + "Login", formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }),
      ChangePassword: (formdata) =>
        axios.post(url + "ChangePassword", formdata, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),

      ForgotPassword: (data) =>
        axios.post(url + "ForgotPassword", data),

      ValidateResetCode: (data) =>
        axios.post(url + "ValidateResetCode", data),

      ResetPassword: (data) =>
        axios.post(url + "ResetPassword", data)
    };
  },

  // -------------------------Admin setting api's-------------------------------------------------

  dbDesignation(url = baseUrl + "Designation/") {
    return {
      GetAllDesignations: () => axios.get(url + "GetAllDesignations"),
      AddEditDesignation: (formData) =>
        axios.post(url + "AddEditDesignation", formData),
      DeleteDesignation: (id) =>
        axios.post(url + `DeleteDesignation?designationId=${id}`),
      GetAllDesignationsByDepartment: (departmentId) => axios.get(url + `GetAllDesignationsByDepartment?departmentId=${departmentId}`),
    };
  },



  dbDepartment(url = baseUrl + "Department/") {
    return {
      GetAllDepartments: () => axios.get(url + "GetAllDepartments"),
      AddEditDepartment: (formData) =>
        axios.post(url + "AddEditDepartment", formData),
      DeleteDepartment: (id) =>
        axios.post(url + `DeleteDepartment?departmentId=${id}`),
      GetAllDepartmentsByLocation: (LocationId) => axios.get(url + `GetAllDepartmentsByLocation?LocationId=${LocationId}`),
    };
  },

  officeLocation(url = baseUrl + "Admin/") {
    return {
      getAllOfficeLocation: () => axios.get(url + "GetOfficeLocationList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      addEditOfficeLocation: (formData) =>
        axios.post(url + "AddEditOfficeLocation", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      delOfficeLocation: (delId) =>
        axios.post(url + `DeleteOfficeLocation?officeLocationId=${delId}`, {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
      GetAllTaskForAdmin: () => axios.get(url + "GetAllTaskForAdmin", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllTaskForAdminWithDate: (fromDate, toDate) => axios.get(url + `GetAllTaskForAdminWithDate?fromDate=${fromDate}&toDate=${toDate}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllTimesheetUnlockRequestById: (employeeid) => axios.get(url + `GetAllTimesheetUnlockRequestById?employeeid=${employeeid}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
    };
  },
  workPrimise(url = baseUrl + "Admin/") {
    return {
      getAll: () => axios.get(url + "GetWorkingPremiseList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      addEdit: (formData) =>
        axios.post(url + "AddEditWorkingPremise", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      del: (delId) =>
        axios.post(url + `DeleteWorkingPremise?workingPremiseId=${delId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
    };
  },
  rewards(url = baseUrl + "Admin/") {
    return {
      getAll: () => axios.get(url + "GetAllRewards", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      addEdit: (formData) => axios.post(url + "AddEditRewards", formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      addEditRewardDetails: (formData) =>
        axios.post(url + "AddEditRewardDetails", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      del: (delId) => axios.post(url + `DeleteRewards?RewardId=${parseInt(delId)}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
    };
  },

  //employee type api's
  dbEmployeeTypes(url = baseUrl + "Admin/") {
    return {
      GetEmployeeTypeList: () => axios.get(url + "GetEmployeeTypeList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetEmployeeTypeById: (empTypeId) =>
        axios.get(url + `GetEmployeeTypeById?employeeTypeId=${empTypeId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      AddEditEmployeeType: (formData) =>
        axios.post(url + "AddEditEmployeeType", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteEmployeeType: (delId) =>
        axios.post(url + `DeleteEmployeeType?employeeTypeId=${delId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        ),
      UserNameCheck: (username) =>
        axios.get(url + `CheckExistingUserName?userName=${username}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      ProjectNameCheck: (username) =>
        axios.get(url + `CheckExistingProjectName?projectName=${username}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      GetAllShifts: () =>
        axios.get(url + "GetAllShifts", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
    };
  },

  // Skill api's -------------------------------------
  skill(url = baseUrl + "Skills/") {
    return {
      // Get all skill.
      getAllSkills: () => axios.get(url + "GetAllSkills"),
    };
  },

  // empoloyee api's --------------------------------------------------------.
  employee(url = baseUrl + "Admin/") {
    return {
      getAll: () => {
        const token = localStorage.getItem("token");
        return axios.get(url + "GetAllEmployees", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      },
      getSelectedEmployee: (empId) =>
        axios.get(url + `GetAllEmployeeDetailsById?employeeID=${empId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      addEdit: (formData) =>
        // axios.post(url + "AddEditEmployees", formData),
        axios({
          method: "post",
          url: url + "AddEditEmployees",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: `Bearer ${token}`
          },
        }),
      del: (delId) => axios.post(url + `DeleteEmployees?employeeId=${delId}`),
      // GetAllEmployees: () => axios.get(url + "GetAllEmployees"),
      GetAllEmployees: () => {
        const token = localStorage.getItem("token");
        return axios.get(url + "GetAllEmployees", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      },
    };
  },

  // Employee Skill's api -------------------------------------------------------------.
  empSkill(url = baseUrl + "Employee/") {
    return {
      // Get all skill of an employee.
      GetLeaveAndDutyTypes: () => axios.get(url + "GetLeaveAndDutyTypes"),
      getEmpSkillById: (empId) =>
        axios.get(
          url + `GetEmployeeSkillDetailsByEmployeeId?employeeId=${empId}`
        ),
      // Add skill to an employee.
      addEditEmpSkill: (formData) =>
        axios.post(url + "AddEditEmployeeSkillDetails", formData),
      // Delete employee skill.
      deleteEmpSkillById: (empSkillId) =>
        axios.post(
          url + `DeleteEmployeeSkillDetails?employeeSkillId=${empSkillId}`
        ),
      GetAllEmployeeList: () => axios.get(url + "GetAllEmployeeList")
    }
  },
  // Employee certifates api -------------------------------------------------------------.
  empCertificates(url = baseUrl + "Employee/") {
    return {
      // Get employee certifcates API.
      getEmpCertificates: (empId) =>
        axios.get(
          url + `EmployeeCertificationDetails?EmployeeCertificationId=${empId}`
        ),
      // AddEdit .
      addEditEmpCertification: (formData) =>
        axios.post(url + "AddEditEmployeeCertificate", formData),
      // Delete.
      delEmpCertification: (delId) =>
        axios.post(url + `DeleteCertificate?EmployeeCertificationId=${delId}`),
    };
  },
  // Employee rewards api ----------------------------------------------------------------.
  empReward(url = baseUrl + "Employee/") {
    return {
      // Get all reward details of an employee.
      getAllEmployeeRewardDetails: () =>
        axios.get(url + "GetAllEmployeeRewardDetails"),
      GetProfilePic: (empId) =>
        axios.get(url + `GetProfilePic?employeeId=${empId}`),
    };
  },

  reward(url = baseUrl + "Rewards/") {
    return {
      // Get details of points redeemed by employee Id.
      getEmployeeRedeemedDetailsById: (employeeId) =>
        axios.get(url + `EmployeeRedeemedDetails?EmployeeId=${employeeId}`),
      // Get proccess reward details with status = 0.
      getAllRedmeededDetails: () => axios.get(url + `GetAllRedmeededDetails`),
      addEditRedeemDetail: (formData) =>
        axios.post(url + "AddEditRedeemDetails", formData),
      getEmployeeRedeemedList: (employeeId) =>
        axios.get(url + `GetEmployeeRedeemedListById?employeeId=${employeeId.payload}`),
      RevertRedeemDetails: (formData) =>
        axios.post(url + "RevertRedeemDetails", formData),
    };
  },

  // items api's.
  items(url = baseUrl + "Admin/") {
    return {
      getAll: () => axios.get(url + "GetItemsList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      addEdit: (itemFormData) => axios.post(url + "AddEditItems", itemFormData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
    };
  },

  // asset api's.
  asset(url = baseUrl + "Admin/") {
    return {
      getAll: () => axios.get(url + "GetAssetList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      // addEdit: (formData) => axios.post(url + "AddEditAsset", formData),
      addEdit: (formData) =>
        axios({
          method: "post",
          url: url + "AddEditAsset",
          data: formData,
          headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
        }),

      del: (delId) => axios.post(url + `DeleteAsset?itemNo=${delId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      DeleteItem: (delId) => axios.post(url + `DeleteItem?itemNo=${delId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLastInsertedId: (itemId) => axios.get(url + `GetLastInsertedId?itemId=${itemId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLastInsertedTableId: (itemId) => axios.get(url + `GetLastInsertedTableId?itemId=${itemId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetFilePath: (filename) => axios.get(url + `DownloadFile?filename=${filename}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),

    };
  },
  //leave type api's
  dbLeaveTypes(url = baseUrl + "Admin/") {
    return {
      GetLeaveTypes: () => axios.get(url + "GetLeaveTypes", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveMasterList: () => axios.get(url + "GetLeaveMasterList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveTypesByEmpId: (EmpId) => axios.get(url + `GetLeaveTypesByEmpId?empId=${EmpId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditLeaveTypes: (formData) =>
        axios.post(url + "AddEditLeaveTypes", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      AddEditLeaveTypesMaster: (formData) => axios.post(url + "AddEditLeaveTypesMaster", formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      DeleteLeaveTypes: (leaveTypeId, type) =>
        axios.post(url + `DeleteLeaveTypes?LeaveTypeId=${leaveTypeId}&type=${type}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
      GetAllEmployeeDetailsByDepartmentId: (departmentId, locationId, requestId, gender) => axios.get(url + `GetAllEmployeeDetailsByDepartmentId?departmentId=${departmentId}&leavetYpeId=${locationId}&requestId=${requestId}&gender=${gender}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAppliedLeavesByEmpId: (EmpId, fromDate, todate, leaderId) => axios.get(url + `GetAppliedLeavesByEmpId?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}&LeaderId=${leaderId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAppliedLeavesOfEmployee: (EmpId, fromDate, todate) => axios.get(url + `GetAppliedLeavesOfEmployee?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveApplicationByEmpId: (EmpId, fromDate, todate) => axios.get(url + `GetLeaveApplicationByEmpId?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveRequestById: (leaveRequestId) => axios.get(url + `GetLeaveRequestById?leaveRequestId=${leaveRequestId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAppliedLeavesByRequestId: (requestId) => axios.get(url + `GetAppliedLeavesByRequestId?requestId=${requestId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddConfigureMail: (formData) => axios.post(url + "AddConfigureMail", formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetConfigurationMailList: () => axios.get(url + "GetConfigurationMailList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetRequestTypeList: () => axios.get(url + "GetRequestTypeList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditMailSendingSettings: (formData) => axios.post(url + "AddEditMailSendingSettings", formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditMailSendingSettingsForTimesheet: (formData) => axios.post(url + "AddEditMailSendingSettingsForTimesheet", formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllMailSendingSettings: (departmentId, employeeid) => axios.get(url + `GetAllMailSendingSettings?DepartmentId=${departmentId}&EmployeeId=${employeeid}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetDutyTypes: () => axios.get(url + "GetLeaveTypes", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveOrDutyTypesByEmpId: (EmpId, requestId) => axios.get(url + `GetLeaveOrDutyTypesByEmpId?empId=${EmpId}&requestId=${requestId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllDutyTypes: () => axios.get(url + "GetAllDutyTypes", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllDutyStatus: () => axios.get(url + "GetAllDutyStatus", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetAllLeaveTypes: () => axios.get(url + "GetAllLeaveTypes", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveFromLeaveMasterList: () => axios.get(url + "GetLeaveFromLeaveMasterList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditDutyTypes: (formData) =>
        axios.post(url + "AddEditDutyTypes", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteDutyTypes: (leaveTypeId) =>
        axios.post(url + `DeleteLeaveTypes?LeaveTypeId=${leaveTypeId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      GetAllCalendarYearType: () => axios.get(url + "GetAllCalendarYearType", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      DeleteLeaveMaster: (itemIds) => axios.post(url + `DeleteLeaveMaster?itemIds=${itemIds}`, {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
    };
  },
  //review rating api's
  dbReviewRating(url = baseUrl + "Appraisal/") {
    return {
      GetRatingList: () => axios.get(url + "GetRatingList"),
      AddEditRating: (formData) =>
        axios.post(url + "AddEditRating", formData),
      DeleteRating: (ReviewId) =>
        axios.post(url + `DeleteRating?RatingId=${ReviewId}`),
    };
  },
  //Calendar Year api's
  dbCalendarYear(url = baseUrl + "Leave/") {
    return {

      AddEditCalanderYear: (formData) =>
        axios.post(url + "AddEditCalanderYear", formData),
      DeleteCalanderYear: (CalendarYear) =>
        axios.post(url + `DeleteCalanderYear?CalanderyearId=${CalendarYear}`),


      AddEditPlannedLeaveApply: (payload) => axios.post(url + "AddEditPlannedLeaveApply", payload),
      GetAllPlannedLeaveAppply: () => axios.get(url + "GetAllPlannedLeaveAppply"),
      GetAllPlannedLeaveToday: () => axios.get(url + "GetAllPlannedLeaveToday"),
      DeletePlannedLeaveApply: (leavereqeuestId) => axios.post(url + `DeletePlannedLeaveApply?leaveId=${leavereqeuestId}`),
      //           axios({
      //         method: "get",
      //         url: url + "GetAllShifts",
      //         headers: { 'Access-Control-Allow-Origin': '*',
      //         'Access-Control-Allow-Headers': '*',
      // },
      //       }),
      AddEditShifts: (formData) =>
        axios.post(url + "AddEditShifts", formData),
      DeleteShifts: (ShiftId) =>
        axios.post(url + `DeleteShifts?ShiftId=${ShiftId}`),
      AddEditLeaveTypeMapping: (leaveTypeMappings) => axios.post(url + "AddEditLeaveTypeMapping", leaveTypeMappings),
      AddEditLeaveApply: (formData) => axios.post(url + "AddEditLeaveApply", formData),
      DeleteLeaveApply: (leavereqeuestId) => axios.post(url + `DeleteLeaveApply?LeaveApplyId=${leavereqeuestId}`),
      DeleteDutyApply: (leavereqeuestId) => axios.post(url + `DeleteDutyApply?DutyApplyId=${leavereqeuestId}`),
      GetAllLeaveStatus: () => axios.get(url + "GetAllLeaveStatus"),
      ApproveLeaveRequest: (leaveRequestId, leaveStatusId, comment) => axios.post(url + `ApproveLeaveRequest?leaveRequestId=${leaveRequestId}&leaveStatusId=${leaveStatusId}&comment=${comment}`),
      ApproveAllLeaveRequest: (leaveRequestId, leaveStatusId, comment) => axios.post(url + `ApproveAllLeaveRequest?leaveRequestIds=${leaveRequestId}&leaveStatusId=${leaveStatusId}&comment=${comment}`),
      RejectLeaveRequest: (leaveRequestId, leaveStatusId, comment) => axios.post(url + `RejectLeaveRequest?leaveRequestId=${leaveRequestId}&leaveStatusId=${leaveStatusId}&comment=${comment}`),
      YearEndProcess: () => axios.post(url + "YearEndProcess"),
      // DeleteRating: (ReviewId) =>
      // axios.post(url + `DeleteRating?RatingId=${ReviewId}`), 
    };
  },
  //role api's
  dbRole(url = baseUrl + "Admin/") {
    return {
      GetRoleList: () => axios.get(url + "GetRoleList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditRole: (formData) =>
        axios.post(url + "AddEditRole", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteRole: (ReoleId) =>
        axios.post(url + `DeleteRole?roleId=${ReoleId}`, {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
    };
  },
  dbduty(url = baseUrl + "Duty/") {
    return {
      AddEditDutyApply: (formData) => axios.post(url + "AddEditDutyApply", formData),
      GetDutyApplicationByEmpId: (EmpId, fromDate, todate) => axios.get(url + `GetDutyApplicationByEmpId?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}`),
      GetDutyRequestByEmpId: (EmpId, fromDate, todate) => axios.get(url + `GetDutyRequestByEmpId?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}`),
      GetDutyRequestById: (dutyRequestId) => axios.get(url + `GetDutyRequestById?dutyRequestId=${dutyRequestId}`),
      GetAppliedDutyByRequestId: (dutyRequestId) => axios.get(url + `GetAppliedDutyByRequestId?dutyRequestId=${dutyRequestId}`),
      GetAppliedDutyByEmpId: (EmpId, fromDate, todate) => axios.get(url + `GetAppliedDutyByEmpId?empId=${EmpId}&fromdate=${fromDate}&todate=${todate}`),
      AddEditDutyTypeMapping: (formData) => axios.post(url + "AddEditDutyTypeMapping", formData),
      GetDutyTypesByEmpId: (EmpId) => axios.get(url + `GetDutyTypesByEmpId?empId=${EmpId}`),

      ApproveDutyRequest: (dutyRequestId, dutyStatusId, comment) => axios.post(url + `ApproveDutyRequest?dutyRequestId=${dutyRequestId}&dutyStatusId=${dutyStatusId}&comment=${comment}`),
      ApproveAllDutyRequest: (dutyRequestId, dutyStatusId, comment) => axios.post(url + `ApproveAllDutyRequest?dutyRequestIds=${dutyRequestId}&dutyStatusId=${dutyStatusId}&comment=${comment}`),
      RejectDutyRequest: (dutyRequestId, dutyStatusId, comment) => axios.post(url + `RejectDutyRequest?dutyRequestId=${dutyRequestId}&dutyStatusId=${dutyStatusId}&comment=${comment}`),

    };
  },
  //Bahavioral Attribute api's
  dbBehavioralAttribute(url = baseUrl + "Appraisal/") {
    return {
      GetAttributeList: () => axios.get(url + "GetAttributeList"),
      AddEditAttribute: (formData) =>
        axios.post(url + "AddEditAttribute", formData),
      DeleteAttribute: (AttributeId) =>
        axios.post(url + `DeleteAttribute?AttributeId=${AttributeId}`),
    };
  },
  //Employee Import api's
  dbEmployeeImport(url = baseUrl + "Employee/") {
    return {

      AddEditEmployeeExcelImport: (formData) =>
        axios.post(url + "AddEditLeaveAndDutyExcelImport", formData),
      AddEditEmployeeTaskExcelImport: (formData) =>
        axios.post(url + "AddEditEmployeeTaskExcelImport", formData),
    };
  },
  //Asset Import api's
  dbAssetImport(url = baseUrl + "Employee/") {
    return {

      AddEditAssetExcelImport: (formData) =>
        axios.post(url + "AddEditAssetExcelImport", formData).catch(error => {
          if (error.response) {
            // Server responded with a status code outside the 2xx range

          } else if (error.request) {
            // No response received

          } else {
            // Other errors

          }
        }),

      // axios({
      //   method: "post",
      //   url: url + "AddEditAssetExcelImport",
      //   data: formData,
      //   headers: { 'Access-Control-Allow-Origin': '*',
      //   'Access-Control-Allow-Headers': '*',
      //   'Access-Control-Allow-Credentials': 'true',
      //   "Content-Type": "multipart/form-data"},
      // }),
    };
  },
  //Potential api's
  dbPotential(url = baseUrl + "Appraisal/") {
    return {
      GetPotentialsList: () => axios.get(url + "GetPotentialsList"),
      AddEditPotentials: (formData) =>
        axios.post(url + "AddEditPotentials", formData),
      DeletePotentials: (PotentialId) =>
        axios.post(url + `DeletePotentials?PotentialId=${PotentialId}`),
    };
  },
  //company policy api's
  dbcompanypolicies(url = baseUrl + "Admin/") {
    return {
      GetCompanyPoliciesList: () => axios.get(url + "GetCompanyPoliciesList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditCompanyPolicies: (formData) =>
        axios.post(url + "AddEditCompanyPolicies", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteCompanyPolicies: (companyPolicyId) =>
        axios.post(
          url + `DeleteCompanyPolicies?companyPolicyId=${companyPolicyId}`, {}
          , {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        ),
    };
  },

  //holiday calendar api's
  dbcalendar(url = baseUrl + "Admin/") {
    return {
      GetHolidayCalendarList: () => axios.get(url + "GetHolidayCalendarList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetRecHolidayCalendarList: () => axios.get(url + "GetRecHolidayCalendarList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetRecHolidayCalendarListByEmp: (employeeid) => axios.get(url + `GetRecHolidayCalendarListByEmp?employeeId=${employeeid}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditHolidayCalendar: (formData) =>
        axios.post(url + "AddEditHolidayCalendar", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteHolidayCalendar: (year) =>
        axios.post(url + `DeleteHolidayCalendar?year=${year}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
      GetRecHolidayCalendarWeeks: (id) => axios.get(url + `GetRecHolidayCalendarWeeks?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GeYearFromtHolidayCalendarList: () => axios.get(url + "GeYearFromtHolidayCalendarList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetHolidayCalendarListById: (year) => axios.get(url + `GetHolidayCalendarListById?year=${year}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetCalanderYearList: () => axios.get(url + "GetCalanderYearList", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetLeaveAndDutyByEmpId: (employeeId, fromDate, toDate) => axios.get(url + `GetLeaveAndDutyByEmpId?empId=${employeeId}&fromDate=${fromDate}&toDate=${toDate}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      GetTimesheetDetailsForDashboardByEmpId: (employeeId) => axios.get(url + `GetTimesheetDetailsForDashboardByEmpId?empId=${employeeId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
    };
  },



  // -------------------------Admin setting api's End-------------------------------------------------

  // employee educational info
  dbempeducationalinfo(url = baseUrl + "Employee/") {
    return {
      GetEmpEducationalInfo: (employeeId) =>
        axios.get(
          url +
          `GetEmployeeEducationalQualificationByEmployeeId?employeeId=${employeeId}`
        ),
      AddEditEmpEducationalInfo: (formData) => {
        axios.post(url + "AddEditEmployeeEducationalQualification", formData);
      },

      DeleteEmpEducationalInfo: (educationalQualificationId) =>
        axios.post(
          url +
          `DeleteEmployeeEducationalQualificationDetails?educationalQualificationId=${educationalQualificationId}`
        ),
    };
  },

  // Qualification api
  dbqualification(url = baseUrl + "Admin/") {
    return {
      GetQualifications: () => axios.get(url + "GetQualifications", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      UpdateProjectStatus: (projectid, projectstatus) =>
        axios.post(
          url + `UpdateProjectStatus?projectid=${projectid}&projectstatus=${projectstatus}`,
          {},  // <-- empty body (since you're sending params in query string)
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        ),

      AddEditEmployeeContactDetails: (formData) => {
        axios.post(url + "AddEditEmployeeContactDetails", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      },
    };
  },

  // Work Experience api
  dbworkexperience(url = baseUrl + "Employee/") {
    return {
      GetPreviousProject: (employeeId) =>
        axios.get(
          url + `GetEmployeeWorkExperienceByEmployeeId?employeeId=${employeeId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
        ),
      GetPreviousProjectDetails: (workExperienceId) =>
        axios.get(
          url +
          `GetEmployeeWorkExperienceById?workExperienceId=${workExperienceId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
        ),
      // AddEditPreviousProjectDetails: (formData) => 
      //   // axios.post(url + "AddEditEmployees", formData),
      //   axios({
      //     method: "post",
      //     url: url + "AddEditEmployeeWorkExperience",
      //     data: formData,
      //     headers: { "Content-Type": "multipart/form-data",
      //     'Access-Control-Allow-Origin': '*',
      //     'Access-Control-Allow-Headers': '*', },
      //   }),
      AddEditPreviousProjectDetails: (formData) =>
        axios.post(url + "AddEditEmployeeWorkExperience", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeletePreviousProject: (workExperienceId) =>
        axios.post(
          url +
          `DeleteEmployeeWorkExperience?workExperienceId=${workExperienceId}`
        ),
    };
  },

  // Previous Company Details api
  dbpreviouscompany(url = baseUrl + "Employee/") {
    return {
      GetEmpPreviousCompanyInfo: (employeeId) =>
        axios.get(
          url +
          `GetAllEmployeePreviousCompanyDetailsByEmployeeId?employeeId=${employeeId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
        ),
      AddEditPreviousCompanyInfo: (formData) =>
        axios.post(url + "AddEditEmployeePreviousCompanyDetails", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeletePreviousCompanyInfo: (employeeCompanyDetailsId) =>
        axios.post(
          url +
          `DeleteEmployeePreviousCompanyDetails?employeeCompanyDetailsId=${employeeCompanyDetailsId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
        ),
    };
  },

  // skill api.
  skill(url = baseUrl + "Admin/") {
    return {
      getAllSkills: () => axios.get(url + "GetAllSkills", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),

    };
  },
  // project api.
  project(url = baseUrl + "Employee/") {
    return {
      getProjectsOfEmployee: (empId) =>
        axios.get(url + `GetProjectDetailByEmployee?EmployeeId=${empId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      getProjectsOfAdmin: (empId) =>
        axios.get(url + `GetProjectDetailByadmin?EmployeeId=${empId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      getAllProjects: () =>
        axios.get(url + `GetAllEmployeeProjectDetails`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      addProject: (formData) =>
        axios.post(url + "AddEmployeeProjects", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      editProject: (formData) =>
        axios.post(url + "EditEmployeeProjects", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      delProject: (delId) =>
        axios.post(url + `DeleteProject?ProjectId=${delId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      // Get project by project id.
      getProjectById: (projectId) =>
        axios.get(url + `GetEmployeeProjectsById?ProjectId=${projectId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      getAllProjectDetails: () =>
        axios.get(url + `GetProjectAllDetails`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),

    };
  },

  // task api.
  task(url = baseUrl + "Employee/") {
    return {
      getProjectDetailsOfEmp: (employeeId) =>
        axios.get(url + `GetProjectDetailByEmployee?EmployeeId=${employeeId}`),
      // get tasks of a particular employee.
      getAllTaskOfEmployee: (employeeId, fromdate, todate) =>
        axios.get(
          url +
          `GetAllTaskByEmployeeId?EmployeeId=${employeeId}&fromdate=${fromdate}&todate=${todate}
        `
        ),
      GetAllTaskByEmployeeIdPedning: (EmployeeId) =>
        axios.get(
          url + "GetAllTaskByEmployeeIdPedning?EmployeeId=" + EmployeeId),
      GetAllLeaveTaskByEmployeeId: (employeeId) =>
        axios.get(
          url +
          `GetAllLeaveTaskByEmployeeId?EmployeeId=${employeeId}
          `
        ),
      GetAllTaskByEmployeeIdForCalView: (employeeId) =>
        axios.get(
          url +
          `GetAllTaskByEmployeeIdForCalView?EmployeeId=${employeeId}
        `
        ),
      GetAllTaskByEmployeeIdForCal: (employeeId) =>
        axios.get(url + `GetAllTaskByEmployeeIdForCal?EmployeeId=${employeeId}`),
      GetAllTaskByEmployeeIdForCalendarViewOnly: (employeeId) =>
        axios.get(url + `GetAllTaskByEmployeeIdForCalendarViewOnly?EmployeeId=${employeeId}`),
      GetAllActivityDetails: () => axios.get(url + "GetAllActivityDetails"),
      GetAllEmployeeByLeaderId: (LeaderId) =>
        axios.get(url + `GetAllEmployeeByLeaderId?LeaderId=${LeaderId}`),

      GetAllProjectListByEmployeeId: (EmployeeId) =>
        axios.get(url + `GetAllProjectListByEmployeeId?EmployeeId=${EmployeeId}`),
      GetAllDutyAndLeaveByEmployeeId: (EmployeeId, fromdate, todate) =>
        axios.get(url + `GetAllDutyAndLeaveByEmployeeId?EmployeeId=${EmployeeId}&fromdate=${fromdate}&todate=${todate}`),
      GetEmployeeBasedOnProjects: (projectIds) =>
        axios.post(url + "GetEmployeeBasedOnProjects", projectIds, {
          headers: { "Content-Type": "application/json" }
        }),

      GetAllProjectListByMangerId: (EmployeeId) =>
        axios.get(url + `GetAllProjectListByMangerId?EmployeeId=${EmployeeId}`),
      GetAllTaskByProjectId: (ProjectId) =>
        axios.get(url + `GetAllTaskByProjectId?ProjectId=${ProjectId}`),
      GetAllTaskByDate: (date, EmployeeId) =>
        axios.get(url + `GetAllTaskByDate?date=${date}&EmployeeId=${EmployeeId}`),
      GetAllEmployeeTaskByEmployeeIdAndProjectId: (EmployeeId, ProjectId, taskId, typeId) =>
        axios.get(url + `GetAllEmployeeTaskByEmployeeIdAndProjectId?EmployeeId=${EmployeeId}&ProjectId=${ProjectId}&taskId=${taskId}&typeId=${typeId}`),

      GetAllEmployeeTaskByEmployeeId: (EmployeeId, ProjectId, startdate, enddate) =>
        axios.get(url + `GetAllEmployeeTaskByEmployeeId?EmployeeId=${EmployeeId}&ProjectId=${ProjectId}&startdate=${startdate}&enddate=${enddate}`),
      // GetAllTasksOfEmployeeExcludingLeaves:(EmployeeId,ProjectId,startdate,enddate) =>
      //   axios.get(url+`GetAllTasksOfEmployeeExcludingLeaves?EmployeeId=${EmployeeId}&ProjectId=${ProjectId}&startdate=${startdate}&enddate=${enddate}`),
      GetAllTasksOfEmployeeExcludingLeaves: (EmployeeId, projectIds, startdate, enddate) => {
        const params = new URLSearchParams();
        params.append('EmployeeId', EmployeeId);

        // Append multiple project IDs
        projectIds.forEach(id => params.append('ProjectIds', id));
        params.append('startdate', startdate);
        params.append('enddate', enddate);

        return axios.get(`${url}GetAllTasksOfEmployeeExcludingLeaves?${params.toString()}`);
      },
      AddEditEmployeeTimeSheetByLeder: (formData) =>
        axios.post(url + "AddEditEmployeeTimeSheetByLeder", formData),
      ApproveTaskStatus: (formData) =>
        axios.post(url + "ApproveTaskStatus", formData),
      GetEmployeeBasedOnLeaveAssignedEmpId: (LeaderId) =>
        axios.get(url + `GetEmployeeBasedOnLeaveAssignedEmpId?LeaderId=${LeaderId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
    };
  },

  projectIssue(url = baseUrl + "ProjectIssue/") {
    return {
      // get all issues.(task)
      GetAllProjectIssueList: () => axios.get(url + "GetAllProjectIssueList"),

    };
  },

  //  Helpdesk api's.
  helpdesk(url = baseUrl + "HelpDesk/") {
    return {
      // get all category.
      getAllCategory: () => axios.get(url + "GetAllTicketCategories"),
      // get all sub catgory.
      getallSubCategory: () => axios.get(url + "GetAllTicketSubCategories"),
      // Add edit ticket.
      addEditTicket: (formData) => axios.post(url + "AddEditTicket", formData),
      AddEditTicketSubCategories: (formData) => axios.post(url + "AddEditTicketSubCategories", formData),
      AddEditTicketCategories: (formData) => axios.post(url + "AddEditTicketCategories", formData),
      DeleteTicketCategories: (categoriesId) =>
        axios.post(url + `DeleteTicketCategories?categoriesId=${categoriesId}`),
      // get all tickets.
      GetAllTicket: () => axios.get(url + "GetAllTicket"),
      GetAllAssignedTicket: () => axios.get(url + "GetAllAssignedTicket"),
      // get ticket ny ticketId.
      getTicketById: (ticketId) =>
        axios.get(url + `GetAllTicketById?ticketid=${ticketId}`),
      // delete a ticket.
      deleteTicket: (ticketId) =>
        axios.post(url + `DeleteTicket?ticketid=${ticketId}`),
      // get all comments.
      getAllComments: () => axios.get(url + "GetAllTicketComments"),
      // add edit comment.
      addEditComment: (formData) =>
        axios.post(url + "AddEditTicketComments", formData),
      // delete comment.
      deleteComment: (commentId) =>
        axios.post(url + `DeleteTicketComments?CommentId=${commentId}`),
      DeleteTicketSubCategories: (commentId) =>
        axios.post(url + `DeleteTicketSubCategories?subcategoriesid=${commentId}`),
      enumlist: () => axios.get(url + "enumlist"),
      //get all tagged users
      GetAllTicketTaggedUserd: () => axios.get(url + "GetAllTicketTaggedUserd"),
      AddUsersToTicket: (formData) => axios.post(url + "AddUsersToTicket", formData)
    };
  },
  // Payroll api's,
  payroll(url = baseUrl + "PayRoll/") {
    return {
      // Add payroll.
      addEditPayroll: (formData) =>
        axios.post(url + "SavePayRollSetup", formData),
      SavePayRoll: (formData) =>
        axios.post(url + "SavePayRoll", formData),
      SavePayRollList: (formData) =>
        axios.post(url + "SavePayRollList", formData),
      // get payroll by employeeId.SavePayRollList
      getPayrollSetup: (employeeId = 0, year = "") =>
        axios.get(url + `GetEmployeePayRollSetup?EmployeeId=${employeeId}&year=${year}`),
      getPayrollSetups: (employeeId = 0, year = "", curdateTime) =>
        axios.get(url + `GetEmployeePayRollSetups?EmployeeId=${employeeId}&year=${year}&curdateTime=${curdateTime}`),
      // delete payroll.
      deletePayrollById: (payrollId) =>
        axios.post(url + `DeletePayRoll?PayRollId=${payrollId}`),
      getPayroll: (employeeId = 0, year = 2025, month = 5) =>
        axios.get(
          url +
          `GetEmployeePayRoll?EmployeeId=${employeeId}&year=${year}&month=${month}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        ),
      // get all privilage details.
      getAllPrivilageLeave: (employeeId = 0) =>
        axios.get(url + `GetAllEmployeePL?EmployeeId=${employeeId}`),
    };
  },
  // Pettycash api's
  pettycash(url = baseUrl + "Finance/") {
    return {
      // get all petty cash.
      getAllPettyCash: () => axios.get(url + "GetPettyCashDetailsList"),
      // add edit petty cash.
      addEditPettyCash: (formData) =>
        axios.post(url + "AddEditPettyCashDetails", formData),
      // deleted petty cash.
      deletePettyCash: (delId) =>
        axios.post(url + `DeletePettyCashDetails?PettyCashDetailsId=${delId}`),
    };
  },
  // Gift voucher api's --------------------------------------------
  giftVoucher(url = baseUrl + "Employee/") {
    return {
      // get all gift voucher's.
      getAllGiftVoucher: () => axios.get(url + "GetGiftVouchersList"),
      AddEditGiftVouchers: (formData) =>
        axios.post(url + "AddEditGiftVouchers", formData),
      deleteGiftVoucher: (voucherId) => axios.post(url + `DeleteGiftVouchers?giftVoucherTrackingId=${voucherId}`),
    };
  },
  // DailyTaskSheet api's 

  dailytask(url = baseUrl + "Employee/") {
    return {
      //add edit daily task
      addEdit: (formData) => axios.post(url + "AddEditEmployeeTimeSheet", formData,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*'
          }
        },
      ),
      AddEmployeeTimesheet: (formData) => axios.post(url + "AddEmployeeTimesheet", formData,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*'
          }
        },
      ),
      DeleteTaskStatusByTaskId: (taskId) => axios.post(url + `DeleteTaskStatusByTaskId?employeetimesheetid=${taskId}`),
      UpdateTask: (formData) => axios.post(url + "UpdateEmployeeTimeSheetByStatus", formData),
      deleteTask: (delId) => axios.post(url + `DeleteEmployeeTimeSheet?employeeTimeSheetId=${delId}`),
      deleteTaskByLeader: (delId) => axios.post(url + `DeleteEmployeeTimeSheetByLeader?employeeTimeSheetId=${delId}`),
      unlockReq: (formData) => axios.post(url + "AddTaskUnlockRequest", formData),
      getUnlockReq: (payload) => axios.get(url + `GetEmployeeApprovedTimesheetUnlockRequest?employeeId=${payload.employeeId}&type=${payload.type}`),
      GetPlannedleaveByEmpId: (employeeId) => axios.get(url + `GetPlannedleaveByEmpId?employeeId=${employeeId}`),
      GetAllEmployeeTimeSheetByEmployeeId: (projectId) => axios.get(url + `GetAllEmployeeTimeSheetByEmployeeId?EmployeeId=${projectId}`),
      GetAllEmployeeTimeSheetByEmployeeIdAndProjectId: (employeeId, projectId) => axios.get(url + `GetAllEmployeeTimeSheetByEmployeeIdAndProjectId?EmployeeId=${employeeId}&ProjectId=${projectId}`),
      GetAllEmployeeTimeSheetByEmployeeIdAndMultpleProjectIds: (employeeId, projectIds, startdate, enddate) => {
        const params = new URLSearchParams();
        params.append('EmployeeId', employeeId);

        // Append multiple project IDs
        projectIds.forEach(id => params.append('ProjectIds', id));
        params.append('startdate', startdate);
        params.append('enddate', enddate);
        return axios.get(`${url}GetAllEmployeeTimeSheetByEmployeeIdAndMultpleProjectIds?${params.toString()}`);
      },

      GetAllEmployeeTimeSheetByEmployeeIdAndMultpleProjectIdsWithTask: (employeeId, projectIds, taskId, typeId, startdate, enddate) => {
        const params = new URLSearchParams();
        params.append('EmployeeId', employeeId);

        // Append each project ID separately (as ProjectId=1&ProjectId=2)
        projectIds.forEach(id => params.append('ProjectIds', id));

        if (taskId != null) params.append('taskId', taskId);
        if (typeId != null) params.append('typeId', typeId);
        params.append('startdate', startdate);
        params.append('enddate', enddate);
        return axios.get(`${url}GetAllEmployeeTimeSheetByEmployeeIdAndMultpleProjectIdsWithTask?${params.toString()}`);
      },

      UpdateProfilePic: (EmployeeId, formData) => axios.post(url + `UpdateProfilePic?employeeId=${EmployeeId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      getLeaveReq: (EmployeeId, type) => axios.get(url + `GetEmployeeLeaveRequest?employeeId=${EmployeeId}&type=${type}`),
      GetAllEmployeeTimeSheetByEmployeeIdAndProjectIdAndDate: (employeeId, projectId, taskId, datefrom, dateto) => axios.get(url + `GetAllEmployeeTimeSheetByEmployeeIdAndProjectIdAndDate?EmployeeId=${employeeId}&ProjectId=${projectId}&taskId=${taskId}&datefrom=${datefrom}&dateto=${dateto}`),

      GetAllEmployeeTimeSheetByEmployeeIdAndMultipleProjectIdAndDate: (employeeId, projectIds, taskId, datefrom, dateto) => {
        const params = new URLSearchParams();
        params.append('EmployeeId', employeeId);

        // Correct: append each projectId individually
        projectIds.forEach(id => params.append('projectIds', id));

        if (taskId != null) params.append('taskId', taskId);
        if (datefrom != null) params.append('datefrom', datefrom);
        if (dateto != null) params.append('dateto', dateto);

        const fullUrl = `${url}GetAllEmployeeTimeSheetByEmployeeIdAndMultipleProjectIdAndDate?${params.toString()}`;
        console.log("Calling API:", fullUrl);

        return axios.get(fullUrl);
      },
      GetAllEmployeeTimeSheetForProjectStatus: ({ employeeId, projectId, taskId, datefrom, dateto }) =>
        axios.get(url + `GetAllEmployeeTimeSheetForProjectStatus`, {
          params: {
            EmployeeId: employeeId,
            ProjectId: projectId, // example: "1,2,3"
            taskId,
            datefrom,
            dateto
          }
        }),
      CheckExistingTaskName: (taskname, projectId, EmployeeId) =>
        axios.get(url + `CheckExistingTaskName?taskName=${taskname}&ProjectId=${projectId}&EmployeeId=${EmployeeId}`),
      GetEmployeeWorkSummary: (EmployeeId, dateFrom, dateTo) => axios.get(url + `GetEmployeeWorkSummary?employeeId=${EmployeeId}&startDate=${dateFrom}&endDate=${dateTo}`),

      UpdateEmployeeTimeSheetProject: (employeeTimeSheetId, projectId, modifiedBy) =>
        axios.post(url + "UpdateEmployeeTimeSheetProject", {
          EmployeeTimeSheetId: employeeTimeSheetId,
          ProjectID: projectId,
          ModifiedBy: modifiedBy,
        }),
    };
  },

  dbSkillCategory(url = baseUrl + "Skills/") {
    return {
      GetAllSkillCategories: () => axios.get(url + "GetSkillCategories"),
      AddEditSkillCategories: (formData) =>
        axios.post(url + "AddEditSkillCategory", formData),
      DeleteSkillCategories: (id) =>
        axios.post(url + `DeleteSkillCategory?skillcategoryid=${id}`),
    };
  },

  // Admin settings Skill api's -------------------------------------
  dbadminSkills(url = baseUrl + "Admin/") {
    return {
      // Get all skill.
      getAllSkills: () => axios.get(url + "GetAllSkills", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditProjectSkills: (formData) =>
        axios.post(url + "AddEditProjectSkills", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteSkill: (id) =>
        axios.post(url + `DeleteSkills?skillId=${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
    };
  },

  // Certifications.
  certifications(url = baseUrl + "Employee/") {
    return {
      getAllCertifications: () => axios.get(url + "GetAllCertificationDetails"),
      AddEditProjectCertification: (formData) =>
        axios.post(url + "AddEditCertificate", formData),
      DeleteCertification: (id) =>
        axios.post(url + `DeleteAdminCertificate?certificationId=${id}`),
    };
  },

  // Technology.
  technologies(url = baseUrl + "Admin/") {
    return {
      GetAllTechnologies: () => axios.get(url + "GetAllTechnologies", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }),
      AddEditTechnology: (formData) =>
        axios.post(url + "AddEditTechnology", formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
      DeleteTechnology: (id) =>
        axios.post(url + `DeleteTechnology?technologyId=${id}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }),
    };
  },
  // Rewards.
  empRewards(url = baseUrl + "Employee/") {
    return {
      getEmployeeRewards: (empId) =>
        axios.get(url + `GetEmployeeRewardsById?employeeId=${empId.payload}`),

    };
  },
  // Appraisal.
  appraisal(url = baseUrl + "Appraisal/") {
    return {
      getAppraisalQuestions: () =>
        axios.get(url + "GetAppraisalQuestionList"),
      getAppraiseeDetails: (empId) =>
        axios.get(url + `GetAppraiseeDetailsByAppraiseeId?AppraiseeId=${empId}`),
      getExpertLevel: () =>
        axios.get(url + "GetExpertLevel"),
      SaveAppraiseeDetailsAndSelfReview: (formData) =>
        axios.post(url + "SaveAppraiseeDetailsAndSelfReview", formData),
      //Goals Achieved
      AddEditGoalsAchieved: (formData) =>
        axios.post(url + "AddEditGoalsAchieved", formData),
      DeleteGoalAchieved: (formData) =>
        axios.post(url + `DeleteGoalAchieved?goalId=${formData}`),
      DeletePerfomanceGoal: (formData) =>
        axios.post(url + `DeletePerfomanceGoal?goalId=${formData}`),
      // DeletePerfomanceGoal:(formData)=>
      // axios.post(url+`DeletePerfomanceGoal?goalId=${formData}`),
      DeleteTechnicalCapability: (formData) =>
        axios.post(url + `DeleteTechnicalCapability?CapabilityId=${formData}`),
      GetGoalsAchievedByAppraisalId: (payload) =>
        axios.get(url + `GetGoalsAchievedByAppraisalId?AppraisalId=${payload.appraisalId}&AppraiseeId=${payload.empId}`),
      //Performance Goals
      GetGoalListByDesignationId: (designationId) =>
        axios.get(url + `GetGoalListByDesignationId?designationId=${designationId}`),
      GetRatingList: () =>
        axios.get(url + "GetRatingList"),
      SavePerformanceByGoals: (formData) =>
        axios.post(url + `SavePerformanceByGoals`, formData),
      GetAllPerformanceByGoalsByAppraiseeId: (empId) =>
        axios.get(url + `GetAllPerformanceByGoalsByAppraiseeId?AppraiseeId=${empId}`),
      //Technical Capability
      GetPotentialsList: () =>
        axios.get(url + "GetPotentialsList"),
      SaveTechinicalCapability: (formData) =>
        axios.post(url + `SaveTechinicalCapability`, formData),
      GetTechinicalCapabilityByAppraiseeId: (empId) =>
        axios.get(url + `GetTechinicalCapabilityByAppraiseeId?AppraiseeId=${empId}`),
      GetAttributeList: () =>
        axios.get(url + "GetAttributeList"),
      SaveBehaviouralAttributes: (formData) =>
        axios.post(url + "SaveBehaviouralAttributes", formData),
      GetBehaviouralAttributesByAppraiseeId: (empId) =>
        axios.get(url + `GetBehaviouralAttributesByAppraiseeId?AppraiseeId=${empId}`),
      SavePerformanceLearnningPlan: (formData) =>
        axios.post(url + "SavePerformanceLearnningPlan", formData),
      GetPerformanceLearningPlanByAppraiseeId: (payload) =>
        axios.get(url + `GetPerformanceLearningPlanByAppraiseeId?AppraiseeId=${payload.empId == 'undefined' ? payload : payload.empId}&year=${payload.year == 0 ? 0 : payload.year}`),
      GetPreviousPerformanceLearningPlanByAppraiseeId: (payload) =>
        axios.get(url + `GetPreviousPerformanceLearningPlanByAppraiseeId?AppraiseeId=${payload.empId == 'undefined' ? payload : payload.empId}&type=${payload.type}&year=${payload.year == 0 ? 0 : payload.year}`),
      SubmitData: (payload) =>
        axios.post(url + `SubmitData?AppraiseeId=${payload.empId}&reviewType=${payload.reviewType}`),
      GetReviewAppraiseeListByReviewerId: (reviewrId) =>
        axios.get(url + `GetReviewAppraiseeListByReviewerId?ReviewerId=${reviewrId}`),
      CheckAppraisalEnabledState: (empId) =>
        axios.get(url + `CheckAppraisalEnabledState?AppraiseeId=${empId}`),

      //admin
      GetAppraisalEnabledAdminList: () =>
        axios.get(url + "GetAppraisalEnabledAdminList"),
      GetAppraisalEnabledEmployeeList: () =>
        axios.get(url + "GetAppraisalEnabledEmployeeList"),
      EnableAllAppraisee: (payload) =>
        axios.post(url + `EnableAllAppraisee`, payload),
      SaveAppraiseeReviewerSetup: (employeeId, reviewer1, reviewer2) => axios.post(url + `SaveAppraiseeReviewerSetup?appraiseeId=${employeeId}&reviewer1Id=${reviewer1}&ReviewerId2=${reviewer2}`),
    };
  },
  // Primary goal
  Dbprimarygoal(url = baseUrl + "Appraisal/") {
    return {
      GetGoalList: () => axios.get(url + "GetGoalList"),
      AddEditGoal: (formData) =>
        axios.post(url + "AddEditGoal", formData),
      DeleteGoal: (payload) =>
        axios.post(url + `DeleteGoal?goalId=${payload.goalId}&DesignationId=${payload.delId}`),
      GetGoalById: (id) => axios.get(url + `GetGoalById?goalId=${id}`),
    };
  },

  DbAppraisalquestions(url = baseUrl + "Appraisal/") {
    return {
      //GetAppraisalQuestionList:  () =>   axios.get(url + "GetAppraisalQuestionList"),
      AddEditAppraisalquestion: (formData) =>
        axios.post(url + "AddEditAppraisalquestion", formData),
      DeleteAppraisalquestion: (id,) =>
        axios.post(url + `DeleteAppraisalquestion?AppraisalQuestionId=${id}`),
    };
  },
  dbReport(url = baseUrl + "Report/") {
    return {
      GetAttendanceSummery: (ReportId, locationId, departmentId, DesignationId, shiftId, empstatus, employeeID, loginId, fromdate, todate, LeaveId, EarlyBY, timerange, month, year, door) => axios.get(url + `GetAttendanceSummery?ReportId=${ReportId}&locationId=${locationId}&departmentId=${departmentId}&DesignationId=${DesignationId}&shiftId=${shiftId}&empstatus=${empstatus}&employeeID=${employeeID}&loginId=${loginId}&fromdate=${fromdate}&todate=${todate}&LeaveId=${LeaveId}&EarlyBY=${EarlyBY}&timerange=${timerange}&month=${month}&year=${year}&door=${door}&pageSize=999999`),
      GetLeaveSummaryList: () => axios.get(url + "GetLeaveSummaryList?pageSize=999999"),
      GetTodaysPunchInPuunchOut: (EmployeeId) => axios.get(url + "GetTodaysPunchInPuunchOut?EmployeeId=" + EmployeeId),
    }
  },
  dbAttendance(url = baseUrl + "Attendance/") {
    return {
      getduration: (empId, attendanceDate) => axios.get(url + `get-duration?employeeId=${empId}&attendanceDate=${attendanceDate}`)
    };
  },





};